import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// [IMPORTANT] Replace these placeholders with your actual Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyC9uj2vCx9DtRsAklPnXAEZX4SzRoi2VGU",
  authDomain: "atithiseva-2ef7f.firebaseapp.com",
  projectId: "atithiseva-2ef7f",
  storageBucket: "atithiseva-2ef7f.firebasestorage.app",
  messagingSenderId: "469645652899",
  appId: "1:469645652899:web:45eca1d66093c00dd56016",
};
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: "select_account",
});

export const requestForToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      // Explicitly register and wait for the service worker to be ready
      await navigator.serviceWorker.register("/firebase-messaging-sw.js");
      const registration = await navigator.serviceWorker.ready;

      const token = await getToken(messaging, {
        vapidKey:
          "BCZjBhKkLtpt-q-s8gy5Z1W0huoZuixxRhjMB6thenTDtmBYcVyXE005XRmIMsp3QEfHqTrxLL7kstCDcenmzpU",
        serviceWorkerRegistration: registration,
      });

      if (token) {
        return token;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

export const onMessageListener = (callback) => {
  return onMessage(messaging, (payload) => {
    if (callback) callback(payload);
  });
};

export { messaging, auth, googleProvider };
